import MarkerClusterer from '@googlemaps/markerclustererplus'

export default {
  name: 'mapPostCodes',
  props: {
    totalSinistersByPostCodes: {
      type: Array
    }
  },
  data: function () {
    return {
      markers: []
    }
  },
  methods: {
    initMap: function () {
      // eslint-disable-next-line
      if (!google) return
      // eslint-disable-next-line
      this.map = new google.maps.Map(document.querySelector('#map'), {
        zoom: 5.3,
        center: { lat: 46.2276, lng: 2.2137 },
        panControlOptions: false,
        streetViewControl: false,
        tilt: 0,
        draggableCursor: 'pointer',
        rotateControl: false,
        clickableIcons: false
      })

      this.handleSetMarkers(this.totalSinistersByPostCodes)
      this.handleGetSelectedPostCode(this.markers)
    },
    handleSetMarkers (dataPostCodes) {
      this.markers = dataPostCodes.map(function (postCode) {
        const postCodeLabel = postCode.total_sinisters.toString()
        // eslint-disable-next-line
        return new google.maps.Marker({
          position: postCode.coordinates,
          label: postCodeLabel,
          postCode: postCode.postal_code,
          icon: require('@/assets/Yellow.svg')
        })
      })

      const clusterStyles = [
        {
          textColor: 'white',
          textSize: '10',
          fontFamily: 'Open Sans',
          url: require('@/assets/images/views/charts/markerClusterBlue.png'),
          height: 50,
          width: 50,
          anchorText: [20, 2]
        },
        {
          textColor: 'white',
          textSize: '10',
          fontFamily: 'Open Sans',
          url: require('@/assets/images/views/charts/markerClusterBlue.png'),
          height: 50,
          width: 50,
          anchorText: [20, 2]
        },
        {
          textColor: 'white',
          textSize: '10',
          fontFamily: 'Open Sans',
          url: require('@/assets/images/views/charts/markerClusterBlue.png'),
          height: 50,
          width: 50,
          anchorText: [20, 2]
        }
      ]
      const mcOptions = {
        styles: clusterStyles
      }
      // eslint-disable-next-line no-new
      new MarkerClusterer(this.map, this.markers, mcOptions)
    },
    handleGetSelectedPostCode (arrMarkers) {
      arrMarkers.forEach(marker => {
        marker.addListener('click', () => {
          this.$emit('marker:click', marker.postCode)
        })
      })
    }
  },
  watch: {
    totalSinistersByPostCodes () {
      this.initMap()
    }
  },
  mounted () {
    this.initMap()
  }
}
